import search from './search'

export default () => {
  search();
}
